export interface LocationsRequest {
  lon: string;
  lat: string;
  radius: string;
  heathCenter?: string;
  checkBoxData?: { name: string; value: boolean }[];
}

export interface LocationItem {
  ApproxValueCd: string;
  CountyNm: string;
  CtrAddress: string;
  CtrCity: string;
  CtrNm: string;
  CtrPhoneNum: string;
  CtrStateAbbr: string;
  CtrZipCd: string;
  Distance: number;
  DwRecordCreateDt: string;
  EndDt: string;
  FilteredResultsReturned: boolean;
  Id: number;
  Latitude: number;
  LocNameDesc: string;
  Longitude: number;
  ParentCtrCity: string;
  ParentCtrNm: string;
  Shape: string;
  SiteUrl: string;
  StateNm: string;
  UrlTxt: string;
  index?: number;
  directionsUrl?: string;
}

export interface ILocationService {
  getLocations(request: LocationsRequest): Promise<LocationItem[]>;
}

export interface DataRefreshDate{
  refreshDate: string;
  refreshTime: string;
}